export default function AuthFormContainer({ children, className = '' }) {
  return (
    <div
      className={`bg-white rounded-2xl w-full max-w-[660px] min-w-0 p-5 md:p-8 overflow-visible ${className}`}
      style={{ position: 'relative', zIndex: 1 }}
    >
      {children}
    </div>
  );
}

